
// Mapping Department ID to Label for Co-Review UI

export const CO_REVIEW_DEPT_OPTIONS = [
  { code: "gm",    label: "總經理部" },
  { code: "fa",    label: "財務會計部" },
  { code: "pt",    label: "採購貿易部" },
  { code: "md",    label: "行銷設計部" },
  { code: "sl",    label: "業務部" },
  { code: "aw",    label: "行政倉儲部" },
  { code: "sp",    label: "上友包裝部" },
  { code: "lg",    label: "法務部" },
  { code: "ap",    label: "行政人事部" },
];

export const CO_REVIEW_MAP: Record<string, string> = {}; // Reserved for email mapping if needed

export function getDeptNameByCode(code: string): string {
  const found = CO_REVIEW_DEPT_OPTIONS.find(d => d.code === code);
  return found ? found.label : code;
}
